import { put, takeLatest, call } from 'redux-saga/effects'
import fetchFromAPI, { getDefaultAutorizedHeaders } from 'helpers/fetchFromApi'
import * as ApiRoute from 'constants/apiRouting'
import UrlHelper from 'helpers/url'
import NoticeHelper from 'helpers/notice'
import { API_URL_LICENSEE_LIST } from 'constants/index'
import Psfs from 'lib/psfs/Psfs'
import { SHOW_NOTICE } from '../notice'
import {
  LICENSEE_APPLICATION_FETCH_TABLE_DATA,
  LICENSEE_APPLICATION_FETCH_FORM_DATA,
  LICENSEE_APPLICATION_CHANGE,
  LICENSEE_APPLICATION_DELETE,
  LICENSEE_APPLICATION_FETCH_TABLE_DATA_SUCCESS,
  LICENSEE_APPLICATION_FETCH_TABLE_DATA_FAILURE,
  LICENSEE_APPLICATION_FETCH_FORM_DATA_SUCCESS,
  LICENSEE_APPLICATION_FETCH_FORM_DATA_FAILURE,
  LOAD_LICENSEE_APPLICATION_FORM,
} from './reducer'

function* licenseeApplicationFetchTableData(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${
        ApiRoute.API_URL_LICENSEE_APPLICATION_TABLE
      }${UrlHelper.getPsfsQuery(action.payload)}`,
    })

    if (!response || !response.error) {
      yield put({
        type: LICENSEE_APPLICATION_FETCH_TABLE_DATA_SUCCESS,
        payload: response,
      })
    } else {
      yield put({
        type: LICENSEE_APPLICATION_FETCH_TABLE_DATA_FAILURE,
        error: response.errors,
      })
    }
  } catch (error) {
    console.log('LICENSEE APPLICATION INTERFACE ERROR', error)
  }
}

function* licenseeApplicationFetchFormData(action) {
  try {
    const { payload } = action
    yield put({ type: LOAD_LICENSEE_APPLICATION_FORM, payload: true })

    const { entityId } = payload
    const formData = {
      licenseeApplication: {},
      applications: [],
      licensees: [],
    }

    const psfs = new Psfs()
    psfs.addFilter('active', 1)
    formData.applications = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${ApiRoute.APPLICATIONS}${UrlHelper.getPsfsQuery({ psfs })}`,
    })

    formData.licensees = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: API_URL_LICENSEE_LIST,
    })

    if (entityId) {
      formData.licenseeApplication = yield call(fetchFromAPI, {
        headers: getDefaultAutorizedHeaders(),
        partUrl: UrlHelper.create(ApiRoute.API_URL_LICENSEE_APPLICATION_ITEM, {
          id: payload.entityId,
        }),
      })
    }

    if (
      formData.applications.hasOwnProperty('error') ||
      formData.licensees.hasOwnProperty('error') ||
      (formData.licenseeApplication &&
        formData.licenseeApplication.hasOwnProperty('error'))
    ) {
      yield put({ type: LICENSEE_APPLICATION_FETCH_FORM_DATA_FAILURE })
    } else {
      yield put({
        type: LICENSEE_APPLICATION_FETCH_FORM_DATA_SUCCESS,
        payload: formData,
      })
    }

    yield put({ type: LOAD_LICENSEE_APPLICATION_FORM, payload: false })
  } catch (error) {
    console.log('LICENSEE APPLICATION ERROR', error)
  }
}

function* licenseeApplicationChange(action) {
  try {
    const { entityId, values } = action.payload
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      method: !entityId ? 'POST' : 'PUT',
      partUrl: !entityId
        ? ApiRoute.API_URL_LICENSEE_APPLICATION_LIST
        : UrlHelper.create(ApiRoute.API_URL_LICENSEE_APPLICATION_ITEM, {
            id: entityId,
          }),
      data: values,
    })

    if (response.error) {
      return yield call(action.promise.resolve, response.errors)
    }

    yield put({
      type: SHOW_NOTICE,
      notice: NoticeHelper.createSuccessObj(
        `Sisense ${entityId === 0 ? 'create' : 'change'} successful`,
      ),
    })

    return yield call(action.promise.resolve, false)
  } catch (error) {
    throw new Error(`LICENSEE APPLICATION INTERFACE ERROR: ${error}`)
  }
}

function* licenseeApplicationDelete(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      method: 'DELETE',
      partUrl: UrlHelper.create(ApiRoute.API_URL_LICENSEE_APPLICATION_ITEM, {
        id: action.payload.entityId,
      }),
    })

    if (response === 204) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createSuccessObj('Application delete successful'),
      })

      return yield licenseeApplicationFetchTableData(action)
    }

    console.log(
      'LICENSEE APPLICATION DELETE UNKNOWN ERROR. RESPONSE: ',
      response,
    )
  } catch (error) {
    console.log('LICENSEE APPLICATION INTERFACE ERROR', error)
  }
}

function* licenseeApplicationSaga() {
  yield takeLatest(
    LICENSEE_APPLICATION_FETCH_TABLE_DATA,
    licenseeApplicationFetchTableData,
  )
  yield takeLatest(
    LICENSEE_APPLICATION_FETCH_FORM_DATA,
    licenseeApplicationFetchFormData,
  )
  yield takeLatest(LICENSEE_APPLICATION_CHANGE, licenseeApplicationChange)
  yield takeLatest(LICENSEE_APPLICATION_DELETE, licenseeApplicationDelete)
}

export default licenseeApplicationSaga
